module.exports = __webpack_public_path__ + "img/motorrad.932efcae.png";